module.exports = __webpack_public_path__ + "static/media/icon_arrow.55e07b85.webp";